import { Types } from "../actions/MachineMaintenanceSummaryListActions";

const initialState = {
    areaGroupList: {},
    mainEquipmentList: {},
    subEquipmentList: {},
    subEquipmentsTaskList: {},
    breakdownReasonGroupData: [],
    breakdownReasonPlaceData: [],
    breakdownEffectData:[],
    breakdownRootCauseData:[],
    pooldata:[]

};

export const MachineMaintenanceSummaryListReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_AREA_GROUP_LIST:
            return {
                ...state,
                areaGroupList: action.payload || state.areaGroupList,
            };
        case Types.SET_MAIN_EQUIPMENT_LIST:
            return {
                ...state,
                mainEquipmentList: action.payload || state.mainEquipmentList,
            };
        case Types.SET_SUB_EQUIPMENT_LIST:
            return {
                ...state,
                subEquipmentList: action.payload || state.subEquipmentList,
            };
        case Types.SET_SUB_EQUIPMENTS_TASK_LIST:
            return {
                ...state,
                subEquipmentsTaskList: action.payload || state.subEquipmentsTaskList,
            };
        case Types.SET_BREAKDOWN_REASON_GROUP_DATA:
            return {
                ...state,
                breakdownReasonGroupData: action.payload?.resultObject || [],
            };
        case Types.SET_BREAKDOWN_REASON_PLACE_DATA:
            return {
                ...state,
                breakdownReasonPlaceData: action.payload?.resultObject || [],
            };
        case Types.SET_BREAKDOWN_EFFECT_DATA:
            return {
                ...state,
                breakdownEffectData: action.payload?.resultObject || [],
            };
        case Types.SET_BREAKDOWN_ROOT_CAUSE_DATA:
            return {
                ...state,
                breakdownRootCauseData: action.payload?.resultObject || [],
            };
        case Types.SET_POOL_DATA:
            return {
                ...state,
                poolData: action.payload?.resultObject || [],
            };


        default:
            return state;
    }
}